import * as types from '../../../constants/ActionTypes';
import service from '../../../service/';

export const setApplicant = applicant => ({
    type: types.SET_APPLICANT,
    applicant,
});
export const setApplicantName = event => ({
    type: types.SET_APPLICANT_NAME,
    event,
});

export const setApplicantSurName = event => ({
    type: types.SET_APPLICANT_SURNAME,
    event,
});

export const setApplicantDateOfBirth = event => ({
    type: types.SET_APPLICANT_DATE_OF_BIRTH,
    event,
});

export const setApplicantCity = event => ({
    type: types.SET_APPLICANT_CITY,
    event,
});

export const setApplicantPostalCode = event => ({
    type: types.SET_APPLICANT_POSTAL_CODE,
    event,
});

export const setApplicantStreet = event => ({
    type: types.SET_APPLICANT_STREET,
    event,
});

export const setApplicantHouseNumber = event => ({
    type: types.SET_APPLICANT_HOUSE_NUMBER,
    event,
});

export const setApplicantPhone = event => ({
    type: types.SET_APPLICANT_PHONE,
    event,
});

export const setApplicantDetails = applicant => ({
    type: types.SET_APPLICANT_DETAILS,
    payload: service.setApplicantDetails(applicant),
});

export const setShowError = fieldName => ({
    type: types.SET_APPLICANT_SHOW_ERROR,
    fieldName,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetails/applicantDetailsActions.js